import React, { useState, useEffect, useRef } from "react";
import { Container, Button, Form, Nav, Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import "../../Common/Assets/Styles/Modules/payroll-revision.scss";
import TenantDropdown from "../../Common/Components/TenantDropdown";
import DateRangePicker from "react-bootstrap-daterangepicker";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import moment from "moment-timezone";
import momentDate from "moment";
import { toast } from "react-toastify";
import { UserManagement } from "../../Common/Services/UserManagement";
import PayrollExportModal from "./PayrollExportModal";
import { File } from "../../Common/Services/File";
import { PayrollRevision } from "../../Common/Services/PayrollRevision";
import { MultiSelectSearchEHids } from "../../Common/Components/MultiSelectSearchEHids";
import { ReactPageLoader } from "../../Common/Components/ReactPageLoader";
import { Utils } from "../../Common/Utilis";

interface PayrollFile {
  id: number;
  startDate: string;
  endDate: string;
  time: string;
  type: string;
  user: string;
  ehid: string;
  fileName: string;
  downloadLink: string;
}

interface FileRecord {
  id: number;
  date: string;
  time: string;
  type: string;
  ehid: number;
  fileName: string;
  downloadlink: string;
}

export default function PayrollRevisionFiles() {
  const datePickerRef = useRef<any>();
  const [activeTab, setActiveTab] = useState("Manual");
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<any>(null);
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [dateRange, setDateRange] = useState<any>("");
  const [hotelList, setHotelList] = useState<any[]>([]);
  const [payrollFilesAutomatic, setPayrollFilesAutomatic] = useState<any[]>([]);
  const [payrollFilesManual, setPayrollFilesManual] = useState<any[]>([]);
  const [selectedHotelId, setSelectedHotelId] = useState<any>(0);
  const [showModal, setShowModal] = useState(false);
  const [hotelsLoading, setHotelsLoading] = useState(false);
  const [payrollRevisionManualLoading, setPayrollRevisionManualLoading] =
    useState(false);
  const [payrollRevisionAuomaticLoading, setPayrollRevisionAutomaticLoading] =
    useState(false);
  const [zipDonwloading, setZipDonwloading] = useState(false);
  const [payrollAutoDownloading, setPayrollAutoDownloading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  let checkAllRef = useRef();

  useEffect(() => {
    if (selectedTenant) {
      setHotelList([]);
      handleReset();
      getHotelsListFromTenantId(selectedTenant?.tenantid);
    }
  }, [selectedTenant]);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleReset = () => {
    setDateRange("");
    setActiveTab("Manual");
    setStartDate(new Date());
    setEndDate(new Date());
    datePickerRef.current.setStartDate(new Date());
    datePickerRef.current.setEndDate(new Date());
    setSelectedHotelId(0);
    setPayrollFilesAutomatic([]);
    setPayrollFilesManual([]);
    setFirstLoad(true);
  };

  const handleExport = () => {
    //handle Export here
    GetPayrollRevisionManual(false);
  };

  const GetPayrollRevisionLogsAutomatic = (isReload = true) => {
    if (isReload) {
      setPayrollRevisionAutomaticLoading(true);
    }

    const request = {
      Fromdate: startDate,
      Todate: endDate,
      HIDs: selectedHotelId?.map((item) => item.id),
      // TenantID: selectedTenant?.tenantid,
      selectedtenantID: selectedTenant?.tenantid,
    };
    PayrollRevision.GetPayrollRevisionLogs(request)
      .then((res) => {
        const data = res?.data?.map((item) => ({ ...item, id: item.srid }));
        setPayrollFilesAutomatic(data || []);
        setPayrollRevisionAutomaticLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setPayrollFilesAutomatic([]);
        setPayrollFilesManual([]);
        setPayrollRevisionAutomaticLoading(false);
      });
  };

  const GetPayrollRevisionManual = (isReload = true) => {
    if (isReload) {
      setPayrollRevisionManualLoading(true);
    }
    const request = {
      Fromdate: startDate,
      Todate: endDate,
      HIDs: selectedHotelId?.map((item) => item.id),
      // TenantID: selectedTenant?.tenantid,
      selectedtenantID: selectedTenant?.tenantid,
    };
    PayrollRevision.GetPayrollRevision(request)
      .then((res) => {
        setPayrollFilesManual(res?.data || []);
        setPayrollRevisionManualLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setPayrollFilesAutomatic([]);
        setPayrollFilesManual([]);
        setPayrollRevisionManualLoading(false);
      });
  };

  const getPayrollData = (isReload = false) => {
    const shouldFetch =
      dateRange && selectedHotelId?.length > 0 && selectedTenant;

    const isShowLoading = firstLoad ? firstLoad : isReload;

    if (shouldFetch) {
      // Only pass true for first load, false afterwards
      GetPayrollRevisionLogsAutomatic(isShowLoading);
      GetPayrollRevisionManual(isShowLoading);
      if (isShowLoading) setFirstLoad(false);
    } else {
      setPayrollFilesAutomatic([]);
      setPayrollFilesManual([]);
    }
  };
  useEffect(() => {
    getPayrollData();
  }, [dateRange, selectedHotelId, selectedTenant, startDate, endDate]);

  //   {
  //     "letterCode": "AMH",
  //     "ehid": 201,
  //     "hotelNameAbbr": "A M Hotel Management"
  // }
  const getHotelsListFromTenantId = (tenantId: number) => {
    setHotelsLoading(true);
    PayrollRevision.GetPayrollRevisionEhidList({ selectedtenantID: tenantId })
      .then((res) => {
        const hotelListData = res?.result?.map((item) => {
          return {
            id: item.ehid,
            description: item.letterCode,
            value: item.letterCode,
            label: item.letterCode,
            isChecked: true,
            ...item,
          };
        });
        setHotelList(hotelListData || []);
        setSelectedHotelId(hotelListData.filter((item) => item?.isChecked));
        setHotelsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setHotelList([]);
        setHotelsLoading(false);
      });
  };

  const handleTenantChange = (tenant) => {
    setSelectedTenant(tenant);
    console.log("Selected Tenant:", tenant);
  };

  const getPayrollRevisionFiles = () =>
    activeTab === "Automatic" ? payrollFilesAutomatic : payrollFilesManual;

  const footerBulkSelectAll = (e) => {
    let ischecked = e.target.checked;
    const payrollFiles = getPayrollRevisionFiles();
    const ids = payrollFiles.map((r) => r.id);
    setSelectedRows(ischecked ? ids : []);
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const payrollFiles = getPayrollRevisionFiles();
    const ids = payrollFiles
      .filter((item) => item?.status?.toLowerCase() != "pending")
      .map((item) => item.id);

    setSelectedRows(isSelect ? ids : []);
    // if (
    //   isSelect ||
    //   (selectedRows?.length > 0 && payrollFiles?.length != selectedRows?.length)
    // ) {
    //   setSelectedRows(ids);
    // } else {
    //   setSelectedRows([]);
    // }
  };
  const downloadAllZipAutomatic = (urls) => {
    setZipDonwloading(true);
    File.DownloadZip({ fileUrls: urls })
      .then(async (res) => {
        console.log(res);
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Payroll-Revision.zip");
        document.body.appendChild(link);
        link.click();
        link.remove();
        setZipDonwloading(false);
        toast.success("File downloaded sucessfully.");
      })
      .catch((err) => {
        console.log(err);
        setZipDonwloading(false);
      });
  };

  const DownloadManualPayrollZIP = (
    requestIds,
    fileName = "Payroll-Revision"
  ) => {
    setPayrollAutoDownloading(true);
    setZipDonwloading(true);
    const request = {
      requestIds: requestIds,
    };
    File.DownloadPayrollZip(request)
      .then(async (res) => {
        console.log(res);
        const blob = res instanceof Blob ? res : new Blob([res]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setPayrollAutoDownloading(false);
        setZipDonwloading(false);
        toast.success("File downloaded sucessfully.");
      })
      .catch((err) => {
        console.log(err);
        setPayrollAutoDownloading(false);
        setZipDonwloading(false);
      });
  };

  const DownloadPayrollZip = (row) => {
    setPayrollAutoDownloading(true);

    const requestId = row?.requestId?.toString();
    DownloadManualPayrollZIP(requestId, requestId);
  };

  const handleBulkDownload = (selectedRows) => {
    //handleBulkDownload
    const payrollFiles = getPayrollRevisionFiles();

    if (activeTab === "Automatic") {
      const urls = selectedRows
        .map((row) =>
          encodeURIComponent(
            payrollFiles.find((file) => file.id === row)?.downloadlink
          )
        )
        .filter(Boolean); // Remove undefined values if any

      downloadAllZipAutomatic(urls);
    } else {
      const requestIDs = selectedRows.map(
        (id) => payrollFiles.find((item) => item.id == id).requestId
      );
      DownloadManualPayrollZIP(requestIDs.join(","));
    }
  };

  const closeBulkAction = () => {
    //
    setSelectedRows([]);
  };

  const handleOnSelect = (row: any) => {
    const id = row?.id;
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((item) => item != id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const getNotSelectable = () => {
    const payrollFiles = getPayrollRevisionFiles();
    return payrollFiles
      .filter((item) => item?.status?.toLowerCase() == "pending")
      .map((item) => item.id);
  };

  const selectRow = {
    mode: "checkbox",
    selected: [...selectedRows],
    nonSelectable: getNotSelectable(),
    nonSelectableClasses: "disable-row",
    onSelect: handleOnSelect,
    onSelectAll: (isSelect, rows) => handleOnSelectAll(isSelect, rows),
    selectionHeaderRenderer: ({ mode, ...rest }) => (
      <Form.Check
        type={mode}
        {...rest}
        label=""
        custom
        disabled={zipDonwloading}
        ref={(chkRef) => {
          if (chkRef) {
            checkAllRef = chkRef;
            const payrollFiles = getPayrollRevisionFiles();
            if (
              selectedRows?.length === payrollFiles.length &&
              payrollFiles?.length > 0
            ) {
              chkRef.checked = true;
            } else {
              chkRef.checked = false;
            }

            if (selectedRows?.length > 0 && !chkRef?.checked) {
              chkRef.indeterminate = true;
            } else {
              chkRef.indeterminate = false;
            }
          }
        }}
      />
    ),
    selectionRenderer: ({ mode, ...rest }) => (
      <>
        {/* <input type={ mode } { ...rest } /> */}
        <Form.Check
          type={mode}
          {...rest}
          label=""
          custom
          disabled={zipDonwloading}
          // checked={selectedRows.includes(row?.id)}
          // disabled={!this.state?.createEditPermission}
        />
      </>
    ),
  };

  const formatChangeType = (cell: any) => {
    if (!cell) return "";
    return cell === "manual changes"
      ? "Manual"
      : cell === "upload changes"
      ? "Upload"
      : cell;
  };

  const formatDownloadLink = (cell: string, row: any) =>
    row.downloadlink ? (
      <a
        href={row.downloadlink}
        className="file-link"
        onClick={(e) => {
          e.preventDefault(); // Prevent default navigation
          window.location.href = row.downloadlink; // Navigate without refresh
        }}
      >
        <EllipsisWithTooltip placement="bottom">{cell}</EllipsisWithTooltip>
      </a>
    ) : row?.status?.toLowerCase() == "pending" ? (
      <span>Processing...</span>
    ) : (
      <span
        className="file-link disabled"
        style={{ color: "gray", cursor: "not-allowed" }}
      >
        <EllipsisWithTooltip placement="bottom">{cell}</EllipsisWithTooltip>
      </span>
    );

  const formatDownloadLinkZIP = (cell: string, row: any) =>
    row?.status?.toLowerCase() == "pending" ? (
      <span>Processing...</span>
    ) : (
      <div
        className="file-link"
        style={{ cursor: "pointer" }}
        onClick={() => DownloadPayrollZip(row)}
      >
        <EllipsisWithTooltip placement="bottom">{`${cell}.zip`}</EllipsisWithTooltip>
      </div>
    );

  // Table columns configuration
  const columnsAutomatic = [
    {
      dataField: "entryDate",
      text: "Date",
      headerClasses: "table-header",
      formatter: (cell: any, row: any, rowIndex: any) => {
        if (!cell) return "";

        return momentDate(cell).format("MM/DD/YY");
      },
    },
    {
      dataField: "entryDate",
      text: "Time",
      headerClasses: "table-header",
      formatter: (cell: any, row: any, rowIndex: any) => {
        if (!cell) return "";

        return momentDate(cell).format("h:mm A");
      },
    },
    // {
    //   dataField: "entryType",
    //   text: "Type",
    //   headerClasses: "table-header",
    //   formatter: formatChangeType,
    // },
    {
      dataField: "lettercode",
      text: "EHID",
      headerClasses: "table-header",
      formatter: (cell: any, row: any, rowIndex: any) => {
        if (!cell) return "";

        return (
          <EllipsisWithTooltip placement="bottom">{cell}</EllipsisWithTooltip>
        );
      },
    },
    {
      dataField: "fileName",
      text: "File Name",
      formatter: formatDownloadLink,
      headerClasses: "table-header",
    },
  ];

  // Table columns configuration
  const columnsManual = [
    {
      dataField: "startDate",
      text: "Start Date",
      headerClasses: "table-header",
      formatter: (cell: any, row: any, rowIndex: any) => {
        if (!cell) return "";

        return momentDate(cell).format("MM/DD/YY");
      },
    },
    {
      dataField: "endDate",
      text: "End Date",
      headerClasses: "table-header",
      formatter: (cell: any, row: any, rowIndex: any) => {
        if (!cell) return "";

        return momentDate(cell).format("MM/DD/YY");
      },
    },
    {
      dataField: "time",
      text: "Time",
      headerClasses: "table-header",
      formatter: (cell: any, row: any, rowIndex: any) => {
        if (!cell) return "";

        return Utils.formatTo12Hour(cell);
      },
    },
    // {
    //   dataField: "type",
    //   text: "Type",
    //   headerClasses: "table-header",
    //   formatter: formatChangeType,
    // },
    {
      dataField: "userName",
      text: "User",
      headerClasses: "table-header",
    },
    {
      dataField: "lettercode",
      text: "EHID",
      headerClasses: "table-header",
      formatter: (cell: any, row: any, rowIndex: any) => {
        if (!cell) return "";

        return (
          <EllipsisWithTooltip placement="bottom">
            {cell.join(", ")}
          </EllipsisWithTooltip>
        );
      },
    },
    {
      dataField: "requestId",
      text: "File Name",
      formatter: formatDownloadLinkZIP,
      headerClasses: "table-header",
    },
  ];

  // Handle tab change
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setSelectedRows([]);
    // handleReset()
  };

  const updateMultiSelectItem = (selectedItem: any) => {
    setSelectedHotelId(selectedItem);
  };

  const handleDateCallback = (start, end, label) => {
    let date = new Date(start._d);
    let calenderYear = date.getFullYear();
    let calenderDate =
      date.getDate() > 9 ? date.getDate() : 0 + "" + date.getDate();
    let calenderMonth =
      date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : 0 + "" + (date.getMonth() + 1);
    // let tempDate = calenderMonth + "/" + calenderDate + "/" + calenderYear;
    let tempDate = calenderYear + "-" + calenderMonth + "-" + calenderDate;

    let datee = new Date(end._d);
    let calenderYeare = datee.getFullYear();
    let calenderDatee =
      datee.getDate() > 9 ? datee.getDate() : 0 + "" + datee.getDate();
    let calenderMonthe =
      datee.getMonth() + 1 > 9
        ? datee.getMonth() + 1
        : 0 + "" + (datee.getMonth() + 1);
    // let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;
    let tempDatee = calenderYeare + "-" + calenderMonthe + "-" + calenderDatee;
    // let maxEndDate = new Date(date);
    // maxEndDate.setMonth(maxEndDate.getMonth() + 3);
    // maxEndDate.setDate(maxEndDate.getDate());
    // if (datee > maxEndDate) {
    //   toast.error(
    //     "Please select the date range less than or equal to 3 months.",
    //     {
    //       position: toast.POSITION.BOTTOM_RIGHT,
    //     }
    //   );

    //   setStartDate((prev) => prev);
    //   setEndDate((prev) => prev);
    //   setDateRange((prev) => prev);

    //   datePickerRef.current.setStartDate(new Date(startDate));
    //   datePickerRef.current.setEndDate(new Date(endDate));
    //   return;
    // }

    setStartDate(tempDate);
    setEndDate(tempDatee);
    setDateRange(tempDate + " - " + tempDatee);
  };

  const isSelectedRow = selectedRows.length > 0;
  const payrollRevisionLoading =
    activeTab === "Automatic"
      ? payrollRevisionAuomaticLoading
      : payrollRevisionManualLoading;

  const payrollRevisionFiles = getPayrollRevisionFiles();

  return (
    <div className="position-relative">
      <Container fluid className="payroll-revision-container">
        <div className="header-section">
          <h2 className="page-title">Payroll Revision Files</h2>
          <Button
            disabled={
              isSelectedRow ||
              !selectedTenant ||
              hotelsLoading ||
              hotelList?.length == 0
            }
            onClick={handleOpenModal}
            variant="primary"
            className="export-btn"
          >
            Export New Revisions
          </Button>
        </div>

        <div
          className={`page-body ${selectedRows.length > 0 ? "set-height" : ""}`}
        >
          <div className="tenant-section">
            <div className="section-body">
              <TenantDropdown
                disabled={isSelectedRow}
                onTenantChange={handleTenantChange}
              />
            </div>
          </div>

          <div className="export-history-section">
            <div className="section-body">
              <div className="d-flex justify-content-between">
                <h4 className="section-title">Export History</h4>
                {selectedTenant &&
                  hotelList &&
                  hotelList?.length > 0 &&
                  selectedHotelId?.length > 0 &&
                  dateRange && (
                    <button className="border-0 bg-white" disabled={isSelectedRow || payrollRevisionLoading} onClick={() => getPayrollData(true)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path d="M4.06189 13C4.02104 12.6724 4 12.3387 4 12C4 7.58172 7.58172 4 12 4C14.5006 4 16.7332 5.14727 18.2002 6.94416M19.9381 11C19.979 11.3276 20 11.6613 20 12C20 16.4183 16.4183 20 12 20C9.61061 20 7.46589 18.9525 6 17.2916M9 17H6V17.2916M18.2002 4V6.94416M18.2002 6.94416V6.99993L15.2002 7M6 20V17.2916" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  )}
                 
              </div>
              {selectedTenant && (
                <>
                  <Nav variant="tabs" className="export-tabs">
                    <Nav.Item>
                      <Nav.Link
                        disabled={isSelectedRow}
                        className={activeTab === "Manual" ? "active" : ""}
                        onClick={() => handleTabChange("Manual")}
                      >
                        Manual
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        disabled={isSelectedRow}
                        className={activeTab === "Automatic" ? "active" : ""}
                        onClick={() => handleTabChange("Automatic")}
                      >
                        Automatic
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <div className="filter-section">
                    <div className="d-flex">
                      <div className="pl-0">
                        <div className="filter-item">
                          <div className="dateRangePicker   align-content-center">
                            <DateRangePicker
                              ref={datePickerRef}
                              onCallback={handleDateCallback}
                              onApply={(event, picker) => {
                                handleDateCallback(picker?.startDate, picker?.endDate, picker?.chosenLabel);
                              }}
                              initialSettings={{
                                startDate: new Date(startDate),
                                endDate: new Date(endDate),
                                maxDate: new Date(),
                                minDate: moment().subtract(60, "days").toDate(),
                                isCustomDate: (date) => {
                                  if (moment(date).isSame(new Date(), "day")) {
                                    return "highlight-current-date";
                                  }
                                  return "";
                                },
                              }}
                            >
                              <button disabled={isSelectedRow}>
                                {dateRange ? (
                                  <div className="d-flex align-items-center info w-auto">
                                    <div className="shared-list" id="dtrange">
                                      <EllipsisWithTooltip placement="top">
                                        {dateRange}
                                      </EllipsisWithTooltip>
                                    </div>
                                  </div>
                                ) : (
                                  "Date"
                                )}
                              </button>
                            </DateRangePicker>
                          </div>
                        </div>
                      </div>
                      <div>
                        {hotelList && hotelList.length > 0 && (
                          <MultiSelectSearchEHids
                            disabled={isSelectedRow}
                            hidofgroup={[]}
                            showNumItems={true}
                            itemList={hotelList}
                            updateMultiSelectItem={updateMultiSelectItem}
                            dataChange={() => {}}
                            isSelectAll={true}
                            filtertitle={"Search EHIDs"}
                            placeholder={"EHID"}
                            noDataFoundText="No EHID Found."
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {selectedHotelId?.length > 0 && dateRange ? (
                    payrollRevisionLoading ? (
                      <ReactPageLoader useas={"payroll-revision"} />
                    ) : (
                      <ToolkitProvider
                        key={activeTab}
                        keyField="id"
                        data={payrollRevisionFiles}
                        columns={
                          activeTab === "Automatic"
                            ? columnsAutomatic
                            : columnsManual
                        }
                      >
                        {(props) => (
                          <div
                            className={`table-container ${
                              activeTab === "Manual" ? "manual-table" : ""
                            }`}
                          >
                            <BootstrapTable
                              {...props.baseProps}
                              bordered={false}
                              selectRow={selectRow}
                              classes="payroll-table"
                              rowClasses="table-row"
                              headerClasses="table-header-row"
                              noDataIndication="No payroll revision files found"
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    )
                  ) : (
                    <></>
                  )}

                  {selectedRows.length > 0 && (
                    <div className="tableFooter TabFooter-Pay">
                      <div className="bulkSelectFooter">
                        {/* this.footerchk.current.indeterminate = false; */}
                        <Form.Check
                          disabled={zipDonwloading}
                          type="checkbox"
                          label=""
                          id="footerBulkCheckBox"
                          ref={(chkRef) => {
                            if (chkRef) {
                              checkAllRef = chkRef;
                              const payrollFiles = getPayrollRevisionFiles();
                              if (
                                selectedRows?.length === payrollFiles.length
                              ) {
                                chkRef.checked = true;
                              } else {
                                chkRef.checked = false;
                              }

                              if (
                                selectedRows?.length > 0 &&
                                !chkRef?.checked
                              ) {
                                chkRef.indeterminate = true;
                              } else {
                                chkRef.indeterminate = false;
                              }
                            }
                          }}
                          onClick={(e: any) => {
                            e.stopPropagation();
                            footerBulkSelectAll(e);
                          }}
                        />
                        <span className="shift-selected-count">
                          {selectedRows?.length} Selected
                        </span>
                        <div className="action-group d-flex flex-row mr-auto">
                          <Button
                            disabled={
                              selectedRows?.length <= 0 || zipDonwloading
                            }
                            className="btn btn-primary"
                            onClick={() => handleBulkDownload(selectedRows)}
                          >
                            Download All
                          </Button>
                        </div>
                        <Button
                          className="closeButton btn-ghost-light"
                          onClick={() => closeBulkAction()}
                        >
                          &times;
                        </Button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
      {showModal && (
        <PayrollExportModal
          show={showModal}
          hotelList={hotelList}
          closeModal={handleCloseModal}
          onExport={handleExport}
          selectedTenantID={selectedTenant?.tenantid}
        />
      )}
    </div>
  );
}
